module.exports = __webpack_public_path__ + "static/media/arch-18.03a260f2.jpg";